module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAOCAYAAADqtqZhAAAAE0lEQVQYV2Nk35TynwEKGIcKBwDp4x2XlNL7jAAAAABJRU5ErkJggg=="